export const unwrapDefaultDocumentText = (text: string, onInvalidEnvelope?: () => void): string => {
	let parsed: unknown;
	try {
		parsed = JSON.parse(text);
	} catch {
		return text;
	}

	if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return text;

	const payload = parsed as Record<string, unknown>;
	if (
		payload.version === 1 &&
		typeof payload.requirementId === "string" &&
		payload.knowledgeType === "document" &&
		typeof payload.updatedAt === "string" &&
		typeof payload.data === "string"
	) {
		return payload.data;
	}

	if (payload.version === 1 || payload.knowledgeType === "document") onInvalidEnvelope?.();
	return text;
};
